export const timeout = <T, U, V>(
    callable: (arg1: T, arg2: U, arg3: V) => void,
    paramT: any,
    paramU: any,
    paramV: any,
    delay: number,
): void => {
    setTimeout(() => {
        callable(paramT, paramU, paramV);
    }, delay);
};
